<template>
  <Modal
    :id="'cmp-royalty-contracts-sidewindow-scale_turnover_form'"
    @cancelled="onCancel"
  >
    <template slot="header"
      >{{ title }} {{ $dft.snakeCaseToWords("turnover") }}
      {{ $dft.snakeCaseToWords("scales") }}</template
    >
    <template slot="body">
      <div class="body-container">
        <div class="form-group">
          <div class="d-flex">
            <div class="flex-column">
              <TextField
                disabled="disabled"
                :id="'scale_name'"
                class="m1"
                v-bind="textFieldConfig"
                :value="turnoverScale.rs.scale_name"
                :placeholder="$t('scale_name')"
                @valuechanged="onTextFieldValueChange"
              />
            </div>
            <div class="flex-column">
              <TextField
                :id="'base_amt'"
                class="m1"
                v-bind="textFieldConfig"
                :value="turnoverScale.rs.base_amt"
                :placeholder="$t('base_amt')"
                @valuechanged="onTextFieldValueChange"
              />
            </div>
          </div>

          <div class="d-flex">
            <div class="flex-column">
              <TextField
                :id="'amt1'"
                class="m1"
                v-bind="textFieldConfig"
                :value="turnoverScale.rs.amt1"
                :placeholder="$t('scale1')"
                @valuechanged="onTextFieldValueChange"
              />
            </div>
            <div class="flex-column">
              <TextField
                :id="'royalty_plus1'"
                class="m1"
                v-bind="textFieldConfig"
                :value="turnoverScale.rs.royalty_plus1"
                :placeholder="$t('Roy')"
                @valuechanged="onTextFieldValueChange"
              />
            </div>
          </div>

          <div class="d-flex">
            <div class="flex-column">
              <TextField
                :id="'amt2'"
                class="m1"
                v-bind="textFieldConfig"
                :value="turnoverScale.rs.amt2"
                :placeholder="$t('scale2')"
                @valuechanged="onTextFieldValueChange"
              />
            </div>
            <div class="flex-column">
              <TextField
                :id="'royalty_plus2'"
                class="m1"
                v-bind="textFieldConfig"
                :value="turnoverScale.rs.royalty_plus2"
                :placeholder="$t('Roy')"
                @valuechanged="onTextFieldValueChange"
              />
            </div>
          </div>

          <div class="d-flex">
            <div class="flex-column">
              <TextField
                :id="'amt3'"
                class="m1"
                v-bind="textFieldConfig"
                :value="turnoverScale.rs.amt3"
                :placeholder="$t('scale3')"
                @valuechanged="onTextFieldValueChange"
              />
            </div>
            <div class="flex-column">
              <TextField
                :id="'royalty_plus3'"
                class="m1"
                v-bind="textFieldConfig"
                :value="turnoverScale.rs.royalty_plus3"
                :placeholder="$t('Roy')"
                @valuechanged="onTextFieldValueChange"
              />
            </div>
          </div>

          <div class="d-flex">
            <div class="flex-column">
              <TextField
                :id="'amt4'"
                class="m1"
                v-bind="textFieldConfig"
                :value="turnoverScale.rs.amt4"
                :placeholder="$t('scale4')"
                @valuechanged="onTextFieldValueChange"
              />
            </div>
            <div class="flex-column">
              <TextField
                :id="'royalty_plus4'"
                class="m1"
                v-bind="textFieldConfig"
                :value="turnoverScale.rs.royalty_plus4"
                :placeholder="$t('Roy')"
                @valuechanged="onTextFieldValueChange"
              />
            </div>
          </div>

          <div class="d-flex">
            <div class="flex-column">
              <TextField
                :id="'amt5'"
                class="m1"
                v-bind="textFieldConfig"
                :value="turnoverScale.rs.amt5"
                :placeholder="$t('scale5')"
                @valuechanged="onTextFieldValueChange"
              />
            </div>
            <div class="flex-column">
              <TextField
                :id="'royalty_plus5'"
                class="m1"
                v-bind="textFieldConfig"
                :value="turnoverScale.rs.royalty_plus5"
                :placeholder="$t('Roy')"
                @valuechanged="onTextFieldValueChange"
              />
            </div>
          </div>
        </div>

        <NTable
          class="dbox1"
          id="royalty-contracts-sidewindow-scale_turnover-list"
          :config="tableConfig"
          :headers="headers"
          :items="royaltyOptions || []"
        >
          <template v-slot:item="{ item, tdcon }">
            <tr>
              <td v-bind="tdcon('channel')">
                <span class="txtov" :title="item['channel']">
                  {{ item["channel"] }}
                </span>
              </td>
              <td v-bind="tdcon('rate')">
                <span class="txtov text-right" :title="item['royalty_rate']">
                  {{ item["royalty_rate"] }} %
                </span>
              </td>
              <td v-bind="tdcon('tab_title_info')">
                <span class="txtov" :title="item['options_display']">
                  {{ item["options_display"] }}
                </span>
              </td>
              <td v-bind="tdcon('activate')">
                <div class="dt-checkbox v2 s1">
                  <input
                    type="checkbox"
                    :name="item.royalty_option_id"
                    :id="item.royalty_option_id"
                    :checked="selectedScales.has(item.royalty_option_id)"
                    @click.stop="e => onScaleSelected(e, item)"
                  />
                  <div class="checkmark"></div>
                </div>
              </td>
            </tr>
          </template>
        </NTable>
      </div>
    </template>

    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">Cancel</button>
      <button class="dt-button v1 s6" @click.stop="onOkClick">Ok</button>
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";
import InputField from "@plugins/text-field/input-field";
import NTable from "@/plugins/datatable/datatable";
import { ContractsService } from "../../services/contracts.service";
import { async } from "rxjs/internal/scheduler/async";
import { EventHooks } from "../../../../plugins/text-field";
import {
  createNTableConfig,
  createTableHeader
} from "../../../../plugins/datatable";
import { set } from "ramda";

export default {
  components: {
    Modal,
    InputField,
    NTable
  },
  props: ["selectedContractDetails"],
  data: function() {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true,
        validationEvent: EventHooks.OnBlur,
        valueChangedEvent: EventHooks.OnBlur
      },

      turnoverScale: this.get_turnover_scale(),
      selectedScales: new Set(),

      royalty_options: []
    };
  },
  mounted: async function() {
    if (this.isAddMode) {
      const res = await ContractsService.newTurnoverScale(this.contract_id);

      this.turnoverScale = {
        ...this.turnoverScale,
        ...res.data
      };
    } else if (this.isEditMode) {
      const res = await ContractsService.editTurnoverScale({
        contract_id: this.contract_id,
        royalty_scale_id: this.royalty_scale_id
      });

      this.turnoverScale = {
        ...this.turnoverScale,
        ...res.data
      };
    }

    this.selectedScales = new Set(
      this.royaltyOptions
        .filter(f => f["turnover_scale"] == "1")
        .map(i => i["royalty_option_id"])
    );
  },
  computed: {
    tableConfig: function() {
      return createNTableConfig({
        headerStyle: 3,
        fullHeight: true
      });
    },
    headers: function() {
      return [
        createTableHeader("channel", { f: 0.5 }),
        createTableHeader("rate", {
          mw: 70,
          ta: "right"
        }),
        createTableHeader("tab_title_info"),
        createTableHeader("activate", { mw: 70, ta: "center" })
      ];
    },
    contract_id: function() {
      return this.$route.params.contract_id;
    },

    royalty_scale_id: function() {
      return this.$route.query.royalty_scale_id;
    },

    mode: function() {
      return this.$route.query.mode;
    },
    isEditMode: function() {
      return this.mode == "edit";
    },
    isAddMode: function() {
      return this.mode == "add";
    },
    title: function() {
      if (this.isEditMode) {
        return "Edit";
      } else if (this.isAddMode) {
        return "Add";
      } else {
        return "";
      }
    },

    royaltyOptions: function() {
      return [
        ...(this.turnoverScale?.physical_royalty_options || []),
        ...(this.turnoverScale?.digital_royalty_options || []),
        ...(this.turnoverScale?.licensing_royalty_options || [])
      ];
    },

    saveTurnoverScale: function() {
      return {
        scale_name: this.turnoverScale?.rs?.scale_name,
        base_amt: this.turnoverScale?.rs?.base_amt,
        amt1: this.turnoverScale?.rs?.amt1,
        amt2: this.turnoverScale?.rs?.amt2,
        amt3: this.turnoverScale?.rs?.amt3,
        amt4: this.turnoverScale?.rs?.amt4,
        amt5: this.turnoverScale?.rs?.amt5,
        royalty_plus1: this.turnoverScale?.rs?.royalty_plus1,
        royalty_plus2: this.turnoverScale?.rs?.royalty_plus2,
        royalty_plus3: this.turnoverScale?.rs?.royalty_plus3,
        royalty_plus4: this.turnoverScale?.rs?.royalty_plus4,
        royalty_plus5: this.turnoverScale?.rs?.royalty_plus5,
        royalty_scale_id: this.turnoverScale?.rs?.royalty_scale_id,
        contract_id: this.contract_id,
        royalty_options: JSON.stringify(Array.from(this.selectedScales)),
        turnover_scale: this.turnoverScale?.rs?.turnover_scale
      };
    }
  },
  methods: {
    onTextFieldValueChange: function(name, value) {
      this.turnoverScale = {
        ...this.turnoverScale,
        rs: {
          ...this.turnoverScale.rs,
          [name]: value
        }
      };
    },

    onScaleSelected: function(e, item) {
      if (e.target.checked) {
        this.selectedScales.add(item.royalty_option_id);
      } else {
        this.selectedScales.delete(item.royalty_option_id);
      }
    },

    onCancel: function() {
      this.$emit("cancelled", true);
    },

    onOkClick: async function() {
      if (this.isAddMode) {
        this.$emit("added", this.saveTurnoverScale);
      } else if (this.isEditMode) {
        this.$emit("edited", {
          //a: [2, 3, 4], // DT: Array<Number> BT: ..
          //b: [{ user_id: 2 }], // DT: Array<Object> BT: Array<User>
          // royaltyOptions: this.royaltyOptions, // DT: Array<Object>  BT: Array<royalty option>
          turnover_scale: this.saveTurnoverScale // DT: Object, BT: Object<Turnover scale>
        });
      }
    },

    get_turnover_scale: function() {
      return {
        rs: {
          scale_name: "Turnover Scale",
          base_amt: "",
          amt1: "",
          amt2: "",
          amt3: "",
          amt4: "",
          amt5: "",
          royalty_plus1: "",
          royalty_plus2: "",
          royalty_plus3: "",
          royalty_plus4: "",
          royalty_plus5: "",
          royalty_scale_id: "",
          contract_id: "",
          turnover_scale: "1"
        },
        royalty_options: []
      };
    }
  }
};
</script>

<style lang="scss">
.cmp-royalty-contracts-sidewindow-scale_turnover_form {
  .royalty-contracts-sidewindow-scale_turnover-list {
    --ntable-height: 170px !important;
    margin-top: 30px;
  }
  .body-container {
    max-height: 460px;
    padding-right: 30px;
    overflow: hidden;
    overflow-y: auto;
    .dt-modal--subtitle {
      &:first-child {
        margin-top: 0;
      }
    }
  }
  .dt-checkbox-control {
    align-items: center;
    .dt-checkbox-label {
      flex: 1;
      padding-left: 10px;
    }
  }

  .d-flex {
    margin: 0 -25px;
    .flex-column {
      width: 100%;
      position: relative;
      padding: 0 25px;
    }
  }

  .dt-checkbox {
    margin: auto !important;
  }

  // counter-reset: section;
  // .rate {
  //   .txtov {
  //     &:before {
  //       counter-increment: section;
  //       content: counter(section) ") ";
  //     }
  //   }
  // }
}
</style>
